module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "container container_com-fundo container_com-margem"
  }, [_c('alerta', {
    attrs: {
      "tipo": _vm.tipoDeAlerta,
      "texto": _vm.mensagemDeAlerta
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "ativo": _vm.loading.visivel,
      "mensagem": _vm.loading.mensagem
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "visualizar-empreendimento u-margem-superior-pequena"
  }, [_c('div', {
    staticClass: "grade__linha grade__linha_alinhar-vertical-centro"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_10 informacoes-emprendimento"
  }, [_c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "nome-empreedimento grade__coluna grade__coluna_10"
  }, [_c('span', [_vm._v(_vm._s(_vm.cotaDeSubsidio.CidadeNome))])]), _vm._v(" "), (true) ? _c('button', {
    staticClass: "no-print botao botao_cor-terciaria botao_com-icone-para-esquerda botao_sem-preenchimento botao_medio",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.redirecionarParaEdicao
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Editar\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna"
  }, [_c('span', {
    staticClass: "texto"
  }, [_vm._v("Projeto:\n                "), _c('span', [_vm._v(_vm._s(_vm.cotaDeSubsidio.ProjetoNome))])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna"
  }, [_c('span', {
    staticClass: "texto"
  }, [_vm._v("Cotas disponíveis:\n                "), _c('span', [_vm._v(_vm._s(_vm.cotaDeSubsidio.Quantidade - _vm.cotaDeSubsidio.QuantidadeUsada))])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna"
  }, [_c('span', {
    staticClass: "texto"
  }, [_vm._v("Cotas utilizadas:\n                "), _c('span', [_vm._v(_vm._s(_vm.cotaDeSubsidio.QuantidadeUsada))])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('span', {
    staticClass: "texto"
  }, [_vm._v("Total de cotas disponibilizadas:\n                "), _c('span', [_vm._v(_vm._s(_vm.cotaDeSubsidio.Quantidade))])])])])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "grade__coluna"
  }, [_c('i', {
    staticClass: "fal fa-chart-network fa-5x"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f7f7d84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/gestao-de-cotas/VisualizarCota.vue
// module id = 1133
// module chunks = 1